<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; padding-bottom:20px"><strong>The Motors Set-list:</strong></p>
<p style="text-indent:0em">Phoney Heaven, Whiskey and Wine, Bring on the Morning Light, Emergency, You Beat the Hell Outta Me, Summertime (Is Calling), Cold Love, Sensation, Be What You Gotta Be, Freeze. Dancing the Night Away.</p>
<p style="text-align:Center"><strong><br/>My favourite top ten Motors songs:</strong></p>
<ol style="list-style-type: decimal">
<li><p>Dancing the Night Away</p></li>
<li><p>That’s What John Said</p></li>
<li><p>Airport</p></li>
<li><p>Phoney Heaven</p></li>
<li><p>Emergency</p></li>
<li><p>Forget About You</p></li>
<li><p>Freeze</p></li>
<li><p>Love and Loneliness</p></li>
<li><p>Be What You Gotta Be</p></li>
<li><p>Day I Found a Fiver</p></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?b6928364